import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-727252ed")

_pushScopeId("data-v-727252ed")
const _hoisted_1 = { class: "pay-success" }
const _hoisted_2 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_4 = { style: {"font-size":"14px"} }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("img", {
      src: require('@/assets/image/succeed.png')
    }, null, 8, ["src"]),
    _createVNode("p", null, _toDisplayString(_ctx.$wordList.ProperAllTextPaySuccessed), 1),
    _hoisted_2,
    _createVNode("p", {
      class: "down",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('invoice')))
    }, [
      _createVNode("img", {
        src: require('@/assets/image/download.png')
      }, null, 8, ["src"]),
      _createTextVNode(" " + _toDisplayString(_ctx.$wordList.ProperAllTextDownReceiptFile), 1)
    ]),
    _hoisted_3,
    _createVNode("p", _hoisted_4, _toDisplayString(_ctx.$wordList.ProperAllTextDownReceiptFileLaterTip), 1)
  ]))
})